(function () {
  'use strict';

  function initContactFields(scope) {
    scope.querySelectorAll('[data-l-contact-field]').forEach(function (wrap) {
      if (wrap.dataset.lContactInit) return;
      wrap.dataset.lContactInit = '1';

      var input = wrap.querySelector('input, textarea');
      if (!input) return;

      var sync = function () {
        wrap.classList.toggle('is-filled', input.value.trim() !== '');
      };

      input.addEventListener('focus', function () {
        wrap.classList.add('is-focused');
      });

      input.addEventListener('blur', function () {
        wrap.classList.remove('is-focused');
        sync();
      });

      input.addEventListener('input', sync);
      sync();
    });
  }

  function initContact(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-l-contact]').forEach(function (root) {
      initContactFields(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initContact();
    });
  } else {
    initContact();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initContact(e.target);
  });
})();
